export default "__VITE_ASSET__BR4H1TaM__"